/**
 * Created by anatoly on 03.04.2025
 */

const RepairHintLogic = {
    type: "repair",
    priority: 9,

    chooseConfig: function () {
        const location = cleverapps.meta.getSelectedLocation();
        const fix = location.getContinuousStage();

        if (fix >= 5) {
            return { delay: 3000, interval: 7000 };
        }

        if (fix >= 3) {
            return { delay: 3000, interval: 3000 };
        }

        return { delay: 3000, interval: 1000 };
    },

    findMove: function () {
        const config = this.chooseConfig();
        if (!config) {
            return;
        }

        const location = cleverapps.meta.getSelectedLocation();
        const sceneComponent = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent);

        if (!sceneComponent || !sceneComponent.roomView || location.stars.getAmount() < location.calcStarsForStage() || location.isRoomCompleted()) {
            return;
        }

        const target = Merge2.current && Merge2.current.isGameMode() ? RepairHintLogic.findNewTaskRow(sceneComponent) : sceneComponent.roomView.getRepairView();
        if (!target) {
            return;
        }

        return {
            type: RepairHintLogic.type,
            delay: config.delay,
            interval: config.interval,
            target
        };
    },

    findNewTaskRow: function (sceneComponent) {
        const newTaskRow = sceneComponent.ordersTable.getRowView("new_task");
        return newTaskRow && sceneComponent.ordersTableView.isVisibleNode(newTaskRow) ? newTaskRow : undefined;
    }
};

AvailableMove.REGISTERED_ALGORITHMS.push(RepairHintLogic);
